import { InfoCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconInfoCircle12Line = createIcon(InfoCircle, 12, "Line");
export const IconInfoCircle16Line = createIcon(InfoCircle, 16, "Line");
export const IconInfoCircle20Line = createIcon(InfoCircle, 20, "Line");
export const IconInfoCircle24Line = createIcon(InfoCircle, 24, "Line");
export const IconInfoCircle32Line = createIcon(InfoCircle, 32, "Line");
export const IconInfoCircle48Line = createIcon(InfoCircle, 48, "Line");
export const IconInfoCircle64Line = createIcon(InfoCircle, 64, "Line");
